import { render } from "./AssetCharts.vue?vue&type=template&id=126a1859&scoped=true"
import script from "./AssetCharts.vue?vue&type=script&lang=js"
export * from "./AssetCharts.vue?vue&type=script&lang=js"

import "./AssetCharts.vue?vue&type=style&index=0&id=126a1859&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-126a1859"]])

export default __exports__